type Auth2FAViewProps = {
  code: string
  codeError: string
  submitError: string
  submitting: boolean
  showPasskeyButton: boolean
  customerAreaLabel: string
  title: string
  subtitle: string
  codeLabel: string
  codePlaceholder: string
  submitLabel: string
  submittingLabel: string
  passkeyLabel: string
  passkeySubmittingLabel: string
  passkeyHintLabel: string
  backLabel: string
  onCodeChange: (value: string) => void
  onCodeBlur: () => void
  onSubmit: () => void
  onPasskeySubmit: () => void
  onBack: () => void
}

export const Auth2FAView = ({
  code,
  codeError,
  submitError,
  submitting,
  showPasskeyButton,
  customerAreaLabel,
  title,
  subtitle,
  codeLabel,
  codePlaceholder,
  submitLabel,
  submittingLabel,
  passkeyLabel,
  passkeySubmittingLabel,
  passkeyHintLabel,
  backLabel,
  onCodeChange,
  onCodeBlur,
  onSubmit,
  onPasskeySubmit,
  onBack,
}: Auth2FAViewProps) => (
  <div className="space-y-4">
    <div className="space-y-1">
      <p className="text-xs font-semibold uppercase tracking-[0.12em] text-(--color-status-info)">{customerAreaLabel}</p>
      <h2 className="text-base font-semibold tracking-tight text-(--color-text-primary)">{title}</h2>
      <p className="text-sm text-(--color-text-secondary)">{subtitle}</p>
    </div>
    <form
      className="space-y-3"
      onSubmit={(event) => {
        event.preventDefault()
        void onSubmit()
      }}
    >
      <label className="grid gap-1 text-sm font-medium text-(--color-text-secondary)">
        <span>{codeLabel}</span>
        <input
          value={code}
          onChange={(event) => onCodeChange(event.target.value)}
          onBlur={onCodeBlur}
          placeholder={codePlaceholder}
          autoComplete="one-time-code"
          className={`ca-input h-11 w-full rounded-lg px-3 text-sm ${
            codeError || submitError ? 'border-(--color-status-error)' : 'border-(--color-border-default)'
          }`}
        />
      </label>
      {codeError ? <p className="text-xs text-(--color-status-error)">{codeError}</p> : null}
      {submitError ? <p className="text-xs text-(--color-status-error)">{submitError}</p> : null}
      <button
        type="submit"
        disabled={submitting}
        className="ca-btn-primary inline-flex h-10 w-full items-center justify-center px-4 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-60"
      >
        {submitting ? submittingLabel : submitLabel}
        </button>
      </form>
      {showPasskeyButton ? (
        <div className="space-y-2 rounded-lg border border-dashed border-(--color-border-default) bg-(--color-bg-page-secondary)/70 p-3">
          <p className="text-xs text-(--color-text-muted)">{passkeyHintLabel}</p>
          <button
            type="button"
            disabled={submitting}
            onClick={() => {
              void onPasskeySubmit()
            }}
            className="ca-btn-secondary inline-flex h-10 w-full items-center justify-center px-4 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-60"
          >
            {submitting ? passkeySubmittingLabel : passkeyLabel}
          </button>
        </div>
      ) : null}
      <button
        type="button"
        onClick={onBack}
        className="ca-btn-secondary inline-flex h-10 w-full items-center justify-center px-4 text-sm font-semibold"
      >
      {backLabel}
    </button>
  </div>
)
